import { reactive } from 'vue'

const theme = reactive({
  agentLogo: '',
  devLogo: 'logo.png',
  apiUrl: 'https://api.metaluxe.com.au/',
  bunnyApiUrl: 'https://api.bunny.net/',

  videoLibraryId: '',
  streamCdnUrl: '',
  streamApiKey: '',

  storageApiPassword: '6d5df3cc-332e-4780-9e48a6166450-4ce8-4cb0',
  cdnUrl: 'https://margaret-ave-pwa.b-cdn.net',
  devFolder: '/margaret-ave-pwa',

  cinematicsIcon: '/img/ui-theme/videos-icon.svg',
  rendersIcon: '/img/ui-theme/renders-icon.svg',
  rangeIcon: '/img/ui-theme/range-icon.svg',
  panoramasIcon: '/img/ui-theme/panoramas-icon.svg',
  '360-ToursIcon': '/img/ui-theme/panoramas-icon.svg',

  dashboardMp4: '/theme/dashboard/background-video.mp4',

  // top level menu
  assetsMenuOrder: ['Cinematics', '360-Tours'],

  orderAssetsMenu: ['3 Bed', 'Amenities', 'Exterior'],

  retreatAsset: {
    panoramas: [0],
    panoramasName: ['Margaret Ave'],
    panoramasUrl: ['https://storage.net-fs.com/hosting/7566552/51/'],
    balconyViews: [0],
    balconyViewsName: ['Margaret Ave'],
    balconyViewsUrl: [''],
    floorplans: [],
    floorplansName: [],
    floorplansUrl: [],
  },
  bedAsset: {
    balconyViews: [0],
    balconyViewsName: ['Margaret Ave'],
    balconyViewsUrl: ['https://storage.net-fs.com/hosting/7566552/51/'],
  },
  aminitiesAsset: {
    balconyViews: [0],
    balconyViewsName: ['Margaret Ave'],
    balconyViewsUrl: ['https://storage.net-fs.com/hosting/7566552/56/'],
  },
})

export default { theme }
